export default class HotelNewWithoutOpinions extends HTMLElement
{
    constructor()
    {
        super();

        this.stylesheet = this.getAttribute('stylesheet');
        this.imgcdnurl = this.getAttribute('imgcdnurl');
        this.data = this.getAttribute('data');
    }

    static get observedAttributes()
    {
        return ['stylesheet', 'imgcdnurl', 'data'];
    }

    attributeChangedCallback(name, oldValue, newValue)
    {
        if (this.shadowRoot) {
            this.shadowRoot.querySelector(`[name="${name}"]`).innerHTML = this[name];
        }
    }

    connectedCallback()
    {
        let shadowRoot = this.attachShadow({mode: 'open'});
        const t = document.querySelector('#hotel-new-without-opinions');
        const instance = t.content.cloneNode(true);
        let data = JSON.parse(this.data);
        instance.querySelector('[name="stylesheet"]').href = this.stylesheet;
        instance.querySelector('[name="title"]').innerHTML = data.title;
        instance.querySelector('[name="body"]').innerHTML = data.body;
        instance.querySelector('[name="hotel-without-opinions-img"]').src = this.imgcdnurl;

        shadowRoot.appendChild(instance);
    }
}
